import { createFeatureSelector, createSelector, MemoizedSelector } from "@ngrx/store";
import { IStatisticsState, StatisticsState } from "./interfaces";
import { IRoundBet } from "../../core/round/interfaces";
import { myBetsAdapter } from "./statistics.reducers";

export const selectStatistics: MemoizedSelector<IStatisticsState, IStatisticsState> = createFeatureSelector(StatisticsState.featureKey);
export const betSelectors = myBetsAdapter.getSelectors(createSelector(selectStatistics, b => b.myBets));
export const selectMyBetsList: MemoizedSelector<IStatisticsState, IRoundBet[]> = createSelector(betSelectors.selectAll, (myBets: IRoundBet[]) => {
    return myBets;
});
export const statisticsReachedLastPageFlag = createSelector(selectStatistics, (state: IStatisticsState) => {
    return state.reachedLastPage;
});
export const statisticsLastModified = createSelector(selectStatistics, (state: IStatisticsState) => {
    return state.lastModified;
});
